// Generic config options for e.g. providing widget with configurable values

import {CrumbItem} from '@te-digi/ui-common-components/dist/components/site-breadcrumb/types';
import setValue from './keyvalue/actionCreators/setValue';
import getValue from './keyvalue/selectors/getValue';
import {RootState} from '../types/rootState';
import {WidgetConfig} from '../types/widgetConfig';

// Customizable values that can be passed to widget via "config" props object
export const APPLICATION_PERIOD_ENDING_WARNING_HOURS =
  'applicationPeriodEndingHours';
export const APPLICATION_PERIOD_ENDING_WARNING_HOURS_DEFAULT = 3 * 24; // 3 days

export const CONFIG_KEY = '_widgets_config';
export const WIDGET_BREADCRUMBS_KEY = '_widgets_breadcrumbs';

export const setConfig = (value: unknown) => setValue(CONFIG_KEY, value);
export const getConfigValue =
  (key: keyof WidgetConfig) => (state: RootState) => {
    const config = getValue<WidgetConfig>(CONFIG_KEY)(state) as WidgetConfig;
    return config?.[key];
  };

export const setWidgetBreadcrumbs = (value: CrumbItem) =>
  setValue(WIDGET_BREADCRUMBS_KEY, value);
export const getWidgetBreadcrumbs = (state: RootState) =>
  getValue(WIDGET_BREADCRUMBS_KEY)(state) as CrumbItem[];

export const getApplicationPeriodWarningHours = (state: RootState) =>
  Number(
    getConfigValue(APPLICATION_PERIOD_ENDING_WARNING_HOURS)(state) ||
      APPLICATION_PERIOD_ENDING_WARNING_HOURS_DEFAULT
  );
